module.exports = __webpack_public_path__ + "img/requirement_analysis.65015040.jpg";